<div class="department-details-view-container" *ngIf="departmentObject" fxLayout="column" fxLayoutGap="15px" >
  <div fxLayout="row" fxLayoutGap="15px">
    <button [disabled]="!(userPermissions | async).department.write" (click)="modify()" mat-stroked-button color="primary"><mat-icon>create</mat-icon> <span> Edytuj</span></button>
  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Dane działu</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Nazwa" [value]="departmentObject.name"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Dział nadrzędny" [value]="departmentObject.parentDepartment?.name"
                            [link]="departmentObject.parentDepartment ? ['/uzytkownicy/dzialy/szczegoly', departmentObject.parentDepartment.uuid] : undefined">

                </app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Przełożony"
                            [value]="departmentObject.supervisor ? departmentObject.supervisor.firstName + ' ' + departmentObject.supervisor.lastName : ''"
                            [link]="departmentObject.supervisor ? ['/uzytkownicy/szczegoly', departmentObject.supervisor.uuid] : undefined"
                >
                </app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

    </div>

  </div>
</div>
